import { DiscountPillDataType } from "../../interfaces/DiscountPillType";
import Discount from "./Discount";

export default function DiscountContainer({
  data,
}: {
  data: DiscountPillDataType;
}) {
  return (
    <div className="vas-align-self-center">
      <Discount data={data} />
    </div>
  );
}
